import React, { FC } from 'react';

interface NextAvailableBadgeProps {
  isLoading: boolean
  nextAvailableLabel: string | null
}

const NextAvailableBadge: FC<NextAvailableBadgeProps> = ({
  isLoading,
  nextAvailableLabel,
}) => {
  if (isLoading) {
    return (
      <span
        className="bg-slate-100 text-slate-400 text-xs rounded-full px-3 py-1 flex-shrink-0 animate-pulse"
        aria-label="Loading availability"
      >
        Loading...
      </span>
    );
  }

  if (nextAvailableLabel) {
    return (
      <span
        className="text-xs px-2 py-0.5 rounded-full font-semibold text-brand flex-shrink-0 whitespace-nowrap"
        style={{ background: 'rgba(var(--portal-color-primary-rgb), 0.07)' }}
        aria-label={`Next available: ${nextAvailableLabel}`}
      >
        {`Next Available: ${nextAvailableLabel}`}
      </span>
    );
  }

  return (
    <span
      className="bg-slate-100 text-slate-400 text-xs italic rounded-full px-3 py-1 flex-shrink-0"
      aria-label="No availability in next 3 months"
    >
      No availability in next 3 months
    </span>
  );
};

export default NextAvailableBadge;
